import React from "react";
import { HardnessItem } from "../../forms/custom-hardness/hardnessResultSummaryForm";

import CustomSection from "../custom-general/custom-section";
import ParseHTML from "../../common/ParseHTML";
import PDFTablePage from "../../themed/pdf/pdfTablePage";

import { getChunkedData } from "../../../utils/utilities";
import { useAppSelector } from "../../../store/configureStore";
import { getReportDetails } from "../../../store/reportDetails";
import { hardnessResultColumns } from "./createCustomHardness";

interface Props {
    data: HardnessItem[];
    remark: string;
}

const HardnessResultReport: React.FC<Props> = ({ data, remark }) => {
    const { itemCountPerPage } = useAppSelector(getReportDetails);
    
    return ( 
        <>
            {getChunkedData(data, itemCountPerPage).map((datum, index) => (
                <CustomSection key={index} sectionTitle="Result" >
                    <div className="p-1">
                        <PDFTablePage data={datum} columns={hardnessResultColumns} />

                        <div className="p-1 border rounded mt-3 bg-light">
                            <div className="form-control"><ParseHTML text={'<strong>REMARK: </strong>' + remark} /></div>
                        </div>
                    </div>
                </CustomSection>
            ))}
        </>
    );
};
 
export default HardnessResultReport;